import * as React from 'react';

import { NekoTestViewProps } from './NekoTest.types';

function NekoTestWebView(props: NekoTestViewProps) {
  return (
    <div>
      <span>{props.name}</span>
    </div>
  );
}

export default NekoTestWebView;
